import { render, staticRenderFns } from "./add_product_feedback.vue?vue&type=template&id=6ea2c592&scoped=true&"
import script from "./add_product_feedback.vue?vue&type=script&lang=js&"
export * from "./add_product_feedback.vue?vue&type=script&lang=js&"
import style0 from "./add_product_feedback.vue?vue&type=style&index=0&id=6ea2c592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2c592",
  null
  
)

export default component.exports